export const LONG_LIVED_IMAGE_CACHE_CONTROL = 'public, max-age=31536000, immutable'
